<div class="close-dialog-btn" (click)="onNoClick()">
  <img src="assets/images/icons/close.svg" alt="close">
</div>

<ng-container *ngIf="isSubGroup; else mainGroup">
  <div class="container">
    <h1 mat-dialog-title class="title" [translate]="title"></h1>
    <div class="text" [innerText]="text | translate"></div>
    <div class="action-btns">
      <button (click)="cancel()" class="action-btn cancel-btn" mat-stroked-button color="primary" [disabled]="loading">
        <span [translate]="'ExdrCommon.Cancel'"></span>
      </button>
      <button (click)="joinSubGroup()" class="action-btn gradient-btn join-btn" mat-flat-button color="primary"
        [disabled]="loading">
        <span [translate]="'JoinGroup.Join'"></span>
      </button>
    </div>
  </div>
</ng-container>
<ng-template #mainGroup>

  <!--AdminApprovalRequired and AnyoneCanJoin-->
  <ng-template [ngIf]="dialogData.membershipOption!==groupMembershipOption.JoinByEmailAddressDomain">
    <div class="container">
      <h1 mat-dialog-title class="title" [translate]="title"></h1>
      <div class="text" [innerText]="text | translate"></div>
      <div *ngIf="dialogData.membershipOption === groupMembershipOption.AdminApprovalRequired" class="desc"
        fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.625rem">
        <div fxFlex="none">
          <span inlineSVG="assets/images/icons/phone.svg"> </span>
        </div>
        <span class="desc-text" [innerText]="desc | translate"></span>
      </div>
      <div class="action-btns">
        <button (click)="cancel()" class="action-btn cancel-btn" mat-stroked-button color="primary"
          [disabled]="loading">
          <span [translate]="'ExdrCommon.Cancel'"></span>
        </button>
        <button (click)="join()" class="action-btn gradient-btn join-btn" mat-flat-button color="primary"
          [disabled]="loading">
          <ng-template [ngIf]="dialogData.membershipOption === groupMembershipOption.AdminApprovalRequired ">
            <span [translate]="'ExdrCommon.Send'"></span>
          </ng-template>
          <ng-template [ngIf]="dialogData.membershipOption === groupMembershipOption.AnyoneCanJoin ">
            <span [translate]="'JoinGroup.Join'"></span>
          </ng-template>
        </button>
      </div>
    </div>
  </ng-template>

  <!--Join by email-->
  <ng-template [ngIf]="dialogData.membershipOption===groupMembershipOption.JoinByEmailAddressDomain">
    <div class="container">
      <h1 *ngIf="!isEmailVerification" mat-dialog-title class="title" [translate]="title"></h1>
      <h1 *ngIf="isEmailVerification" mat-dialog-title class="title">{{'NotificationDialog.VerificationCode' |
        translate}}</h1>
      <div *ngIf="!isEmailVerification && !allowAnyDomain " class="text"
        [innerHTML]="text | translate: {value: dialogData.groupName}"></div>
      <div *ngIf="!isEmailVerification && allowAnyDomain " class="text">
        {{'NotificationDialog.ProvideEmailMsg' | translate}}
      </div>
      <div *ngIf="isEmailVerification" class="text">
        {{'NotificationDialog.SentCodeMsg' | translate}}: <strong>{{form.value.email}}</strong>.
        {{'NotificationDialog.EnterCodeMsg' | translate}}
      </div>
      <div class="allowed-domains-area"
        *ngIf="!isEmailVerification && !allowAnyDomain && dialogData.allowedDomains.length">
        <div class="inner-wrapper" [innerHTML]="domainsFull">
        </div>
      </div>
      <form [formGroup]="form" *ngIf="!isEmailVerification">
        <mat-form-field class="email-input custom-outline" appearance="outline">
          <mat-label>{{'Email' | translate}}</mat-label>
          <input matInput required formControlName="email" [disabled]="loading">

          <mat-error *ngIf="form.get('email').errors?.validDomain && form.get('email').touched" class="invalid">
            {{'LoginForm.DomainNotListed' | translate}}
          </mat-error>

          <mat-error *ngIf="form.get('email').errors?.email && form.get('email').touched" class="invalid">
            {{'EspLoginDialog.IncorrectEmail' | translate}}
          </mat-error>

          <mat-error *ngIf="form.get('email').errors?.required && form.get('email').touched" class="invalid">
            {{'EspLoginDialog.RequiredField' | translate}}
          </mat-error>

        </mat-form-field>
      </form>
      <mat-form-field *ngIf="isEmailVerification" class="email-input custom-outline" appearance="outline">
        <mat-label>{{'code' | translate}}</mat-label>
        <input matInput required [formControl]="codeCtrl" [disabled]="loading">
      </mat-form-field>

      <div class="action-btns">
        <button (click)="cancel()" class="action-btn cancel-btn" [disabled]="loading" mat-stroked-button
          color="primary">
          <span [translate]="'ExdrCommon.Cancel'"></span>
        </button>
        <button *ngIf="!isEmailVerification" [disabled]="loading || form.invalid" (click)="sendVerficationEmail()"
          class="action-btn gradient-btn join-btn" mat-flat-button color="primary">
          <span [translate]="'JoinGroup.Join'"></span>
        </button>
        <button *ngIf="isEmailVerification" [disabled]="loading || codeCtrl.invalid" (click)="verifyCode()"
          class="action-btn gradient-btn join-btn" mat-flat-button color="primary">
          <span>{{'done' | translate}}</span>
        </button>
      </div>
    </div>
  </ng-template>
</ng-template>